import {Message, useLegacyModalContext} from '~/components'
import {useFieldValue} from '@eitje/form'
import {ALLOWED_NEGATIVE_DISCOUNT_FIELDS} from './discount_constraints'
import {useEffect} from 'react'

export const NegativeDiscountWarning = () => {
	const {setModalProps} = useLegacyModalContext()
	const discountType = useFieldValue('discount')
	const discountAmount = useFieldValue(discountType)

	const showWarning = ALLOWED_NEGATIVE_DISCOUNT_FIELDS.includes(discountType) && discountAmount < 0

	useEffect(() => setModalProps({confirmSubmit: showWarning}), [discountType, discountAmount])

	if (showWarning) return <Message baseColor="red" t="billing.price_agreement.negative_discount_warning" />
}
